import React from 'react';
import moment from 'moment';

export const cellRendererNumber = (value) => {
  if (!value) return '0';
  return value;
};

export const cellRendererCheck = (value) => {
  if (!value) return '-';
  return value;
};
export const cellRenderRefillNo = (value) => {
  if (!value) return '0';
  return value;
};
export const cellRendererCheck1 = (value) => {
  if (!value) return '-';
  return value.fileName;
};

export const cellRendererToolTip = (row) => {
  if (!row.faxStatus) return '-';
  return (<span title={row.faxStatusToolTip}>{row.faxStatus}</span>);
}

export const currencyFormat = (value) => {
  if (!value || isNaN(value)) return '$0.00';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-$' +
          (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {'$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};

export const currencyToBlank = (value) => {
  if (!value || isNaN(value)) return '-';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-$' +
          (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {'$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};


export const decimalFormat = (value) => {
  if (!value || isNaN(value)) return '0.00';
  if (value < 0)
    return (
      <span className='text-danger text-end'>
        {'-' + (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
  else
    return (
      <span className='text-end'>
        {value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
      </span>
    );
};

export const fileFormatter = (row, download) => {
  const { files } = row;
  if (files && files.length) {
    return files.map((file, index) => {
      return (
        <span
          className='fax-link'
          key={`${file.fileName}${index}`}
          onClick={() => download(file)}
        >
          {file.fileName}
          <br />
        </span>
      );
    });
  }
  return <span>There is no attachment</span>;
};

export const dateFormate = (value) => {

  if (!value) return '-';
  return moment(new Date(value)).format('MM/DD/YYYY');
};

export const dateTime = (value) => {
  if (!value) return '-';
  return moment(new Date(value)).format('MM/DD/YYYY LTS');
};

export const timeFormate = (value) => {
  if (!value) return '-';
  return moment(new Date(value)).format('hh:mm A');
};

export const percpercentageformate = (value) => {
  if (!value) return '-';
  return value.toFixed(2) + '%';
};

export const PlanSpendPMPMSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'quater',
    text: 'Quarter',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter:false,
    cellRenderer: (row) => cellRendererCheck(row.quater),
  },
  {
    dataField: 'quaterSpend',
    text: 'Quarter PMPM',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.quaterSpend),
  },
  {
    dataField: 'activeMember',
    text: 'Member Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.activeMember),
  },
];

export const ClientDashBoardDetailsColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'pharmacyNPI',
    text: 'Pharmacy NPI',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyNPI),
  },
  {
    dataField: 'pharmacy',
    text: 'Pharmacy Name',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacy),
  },
    {
    dataField: 'pharmacyAddress',
    text: 'Pharmacy Address',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyAddress),
  },
  {
    dataField: 'bin',
    text: 'BIN',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.bin),
  },
  {
    dataField: 'processorControlNumber',
    text: 'PCN',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.processorControlNumber),
  },
  {
    dataField: 'groupId',
    text: 'Group ID',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.groupId),
  },
  {
    dataField: 'patientRelationshipCode',
    text: 'Patient Relationship Code',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.patientRelationshipCode),
  },
  {
    dataField: 'prescriberId',
    text: 'Prescriber NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.prescriberId),
  },
  {
    dataField: 'prescriberFirstName',
    text: 'Prescriber First Name',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.prescriberFirstName),
  },
  {
    dataField: 'prescriberLastName',
    text: 'Prescriber Last Name',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.prescriberLastName),
  },
  {
    dataField: 'datePrescWritten',
    text: 'Date Presc Written',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.datePrescWritten),
  },
  {
    dataField: 'dateOfService',
    text: 'Date Of Service',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.dateOfService),
  },
  {
    dataField: 'rxNumber',
    text: 'Rx Number',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.rxNumber),
  },
  {
    dataField: 'fillNumber',
    text: 'Fill Number',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.fillNumber),
  },
  {
    dataField: 'ndc',
    text: 'NDC',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },
    {
    dataField: 'drugName',
    text: 'Drug Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
  {
    dataField: 'drugManufacturer',
    text: 'Drug Manufacturer',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugManufacturer),
  },
  {
    dataField: 'drugClass',
    text: 'Drug Class',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugClass),
  },
  {
    dataField: 'brandGenericFlag',
    text: 'Brand Generic Flag',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.brandGenericFlag),
  },
  {
    dataField: 'quantityDispensed',
    text: 'Quantity Dispensed',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.quantityDispensed),
  },
    {
    dataField: 'daysSupply',
    text: 'Days Supply',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.daysSupply),
  },
  {
    dataField: 'compoundCode',
    text: 'Compound Code',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.compoundCode),
  },
  {
    dataField: 'prodSelectionCode',
    text: 'Prod Selection Code',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.prodSelectionCode),
  },
  {
    dataField: 'profitLoss',
    text: 'Profit Loss',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.profitLoss),
  },
   {
    dataField: 'retailDrugCost',
    text: 'Retail Drug Cost',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.retailDrugCost),
  },
 {
    dataField: 'planPayAmount',
    text: 'Plan Pay Amount',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.planPayAmount),
  },
   {
    dataField: 'patientPayAmt',
    text: 'Patient Pay Amt',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.patientPayAmt),
  },

   {
    dataField: 'totalAmountPaid',
    text: 'Total Amount Paid',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.totalAmtPaid),
  },

  {
    dataField: 'rebateAmount',
    text: 'Rebate Amount',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.rebateAmount),
  },
];

export const GenericVSBrandSummaryDataColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
    {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  //   {
  //   dataField: 'ndc',
  //   text: 'NDC',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.ndc),
  // },
  // {
  //   dataField: 'drugName',
  //   text: 'Drug Name',
  //   sort: true,
  //   width: 80,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.drugName),
  // },
  {
    dataField: 'brandFlagCount',
    text: 'Brand Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.brandFlagCount),
  },
  {
    dataField: 'genericFlagCount',
    text: 'Generic Count',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.genericFlagCount),
  },
];

export const CostPerRxSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  //   {
  //   dataField: 'cardholderId',
  //   text: 'Member ID',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.cardholderId),
  // },
  //  {
  //   dataField: 'memberName',
  //   text: 'Member Name',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.memberName),
  // },
  {
    dataField: 'planPayAmount',
    text: 'Plan Pay Amount Per Rx',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.planPayAmount),
  },
  {
    dataField: 'patientPayAmt',
    text: 'Patient Pay Amount Per Rx',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.patientPayAmt),
  },
  {
    dataField: 'totalAmtPaid',
    text: 'Total Amount Paid Per Rx',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.totalAmtPaid),
  },
    {
    dataField: 'claimCount',
    text: 'Claim Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.claimCount),
  },
];
export const NonspecialityvsspecialitysummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  {
    dataField: 'specialityClaimCount',
    text: 'Speciality Claim Count',
    sort: true,
    width: 150,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.specialityClaimCount),
  },
   {
    dataField: 'specialityDrugSpend',
    text: 'Speciality Drug Spend',
    sort: true,
    width: 150,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.specialityDrugSpend),
  },
  {
    dataField: 'nonSpecialityClaimCount',
    text: 'Non - Speciality Claim Count',
    sort: true,
    width: 150,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.nonSpecialityClaimCount),
  },
    {
    dataField: 'nonSpecialityDrugSpend',
    text: 'Non - Speciality Drug Spend',
    sort: true,
    width: 150,
    show: true,
    inputType: 'text',
    hideColFilter:false,
    cellRenderer: (row) => currencyFormat(row.nonSpecialityDrugSpend),
  },
];

export const PrescriberVolumeSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  // {
  //   dataField: 'monthName',
  //   text: 'Month',
  //   sort: true,
  //   width: 80,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.monthName),
  // },
  {
    dataField: 'providerNPI',
    text: 'Provider NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.providerNPI),
  },
  {
    dataField: 'providerName',
    text: 'Provider Name',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.providerName),
  },
   {
    dataField: 'claimCount',
    text: 'Claim Count',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.claimCount),
  },
];

export const PharmacySpendSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  //   {
  //   dataField: 'monthName',
  //   text: 'Month',
  //   sort: true,
  //   width: 80,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.monthName),
  // },
    {
    dataField: 'pharmacyNpi',
    text: 'Pharmacy NPI',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyNpi),
  },
  {
    dataField: 'phamacyName',
    text: 'Pharmacy Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.phamacyName),
  },
  {
    dataField: 'totalAmountSpend',
    text: 'Total Amount Spend',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.totalAmountSpend),
  },
];

export const PrescriberSpendSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  // {
  //   dataField: 'monthName',
  //   text: 'Month',
  //   sort: true,
  //   width: 80,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.monthName),
  // },
  {
    dataField: 'providerNPI',
    text: 'Provider NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.providerNPI),
  },
  {
    dataField: 'providerName',
    text: 'Provider Name',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.providerName),
  },
    {
    dataField: 'totalAmountPaid',
    text: 'Total Amount Paid',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.totalAmountPaid),
  },
];

export const DrugVolumeSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'ndc',
    text: 'NDC',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },

  {
    dataField: 'drugName',
    text: 'Drug Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
    {
    dataField: 'claimCount',
    text: 'Claim Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.claimCount),
  },
];


export const GenericBrandSpendSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  //  {
  //   dataField: 'ndc',
  //   text: 'NDC',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.ndc),
  // },
  // {
  //   dataField: 'drugName',
  //   text: 'Drug Name',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.drugName),
  // },
  {
    dataField: 'brandSpendPercentage',
    text: 'Brand Spend Percentage',
    sort: true,
    width: 180,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => percpercentageformate(row.brandSpendPercentage),
  },
  {
    dataField: 'genericSpendPercentage',
    text: 'Generic Spend Percentage',
    sort: true,
    width: 180,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => percpercentageformate(row.genericSpendPercentage),
  },
];

export const EligibilityDetailDataColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'planCode',
    text: 'Plan Code',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.planCode),
  },
  {
    dataField: 'groupCode',
    text: 'Group Code',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.groupCode),
  },
  {
    dataField: 'cardholderId',
    text: 'Cardholder Id',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.cardholderId),
  },
  {
    dataField: 'subscriberId',
    text: 'Subscriber Id',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.subscriberId),
  },
  {
    dataField: 'personCode',
    text: 'Person Code',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.personCode),
  },
  {
    dataField: 'gender',
    text: 'Gender',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.gender),
  },
  {
    dataField: 'memberFirstName',
    text: 'Member First Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.memberFirstName),
  },
  {
    dataField: 'memberLastName',
    text: 'Member Last Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.memberLastName),
  },
  {
    dataField: 'memberDateofBirth',
    text: 'Member Date of Birth',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.memberDateofBirth),
  },
  {
    dataField: 'memberAge',
    text: 'Member Age',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.memberAge),
  },
  {
    dataField: 'address1',
    text: 'Address1',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.address1),
  },

  {
    dataField: 'address2',
    text: 'Address2',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.address2),
  },
  {
    dataField: 'city',
    text: 'City',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.city),
  },
  {
    dataField: 'zip5',
    text: 'Zip5',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.zip5),
  },
  {
    dataField: 'zip4',
    text: 'Zip4',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.zip4),
  },
  {
    dataField: 'hygeiaCardholderId',
    text: 'Hygeia Cardholder Id',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.hygeiaCardholderId),
  },
    {
    dataField: 'hygeiaUniqueId',
    text: 'Hygeia Unique Id',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.hygeiaUniqueId),
  },
];

export const SpecialityDrugUtilizationSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'ndc',
    text: 'NDC',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },
  {
    dataField: 'drugName',
    text: 'Drug Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
 
  {
    dataField: 'specialityClaimCount',
    text: 'Speciality Claim Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.specialityClaimCount),
  },
];

export const PharmacySpendRebateSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  //   {
  //   dataField: 'pharmacyId',
  //   text: 'Pharmacy ID',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.pharmacyId),
  // },
  // {
  //   dataField: 'pharmacyName',
  //   text: 'Pharmacy Name',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.pharmacyName),
  // },
  
  {
    dataField: 'planPayAmount',
    text: 'Plan Pay Amount',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.planPayAmount),
  },
  {
    dataField: 'patientPayAmt',
    text: 'Patient Pay Amount',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.patientPayAmt),
  },
   {
    dataField: 'rebateAmount',
    text: 'Rebate Amount',
    sort: true,
    width: 160,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => currencyFormat(row.rebateAmount),
  },
];

export const PharmacyVolumeSummaryColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  // {
  //   dataField: 'monthName',
  //   text: 'Month',
  //   sort: true,
  //   width: 80,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.monthName),
  // },
   {
    dataField: 'pharmacyNpi',
    text: 'Pharmacy NPI',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyNpi),
  },
  {
    dataField: 'phamacyName',
    text: 'Pharmacy Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.phamacyName),
  },
   {
    dataField: 'totalClaimCount',
    text: 'Claim Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.totalClaimCount),
  },
];

 
 export const PADetailDataColumns = [
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'authCode',
    text: 'Auth Code',
    sort: true,
    width: 80,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.authCode),
  },
  {
    dataField: 'cardholderId',
    text: 'Member ID',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.cardholderId),
  },
  {
    dataField: 'planCode',
    text: 'Plan Code',
    sort: true,
    width: 100,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.planCode),
  },
  {
    dataField: 'prescriberNpi',
    text: 'Prescriber NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.prescriberNpi),
  },
  {
    dataField: 'pharmacyNpi',
    text: 'Pharmacy NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyNpi),
  },
  {
    dataField: 'ndc',
    text: 'Ndc',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },
  {
    dataField: 'drugName',
    text: 'Drug Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
  {
    dataField: 'requestType',
    text: 'Request Type',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.requestType),
  },
  {
    dataField: 'status',
    text: 'Status',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.status),
  },
  {
    dataField: 'intake',
    text: 'Intake',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.intake),
  },
  {
    dataField: 'urgency',
    text: 'Urgency',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.urgency),
  },
    {
    dataField: 'authStartDate',
    text: 'Authorization Start Date',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => dateFormate(row.authStartDate),
  },
  {
    dataField: 'authEndDate',
    text: 'Authorization End Date',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => dateFormate(row.authEndDate),
  },
];

export const PAAuthSummaryDataColumns=[
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
  {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  {
    dataField: 'approvedCount',
    text: "Approved Count",
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.approvedCount),
  },
   {
    dataField: 'approvedPercentage',
    text: "Approved Percentage",
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => percpercentageformate(row.approvedPercentage),
  },
  {
    dataField: 'denaiedCount',
    text: "Denied Count",
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.denaiedCount),
  },
   {
    dataField: 'denaiedPercentage',
    text: "Denied Percentage",
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => percpercentageformate(row.denaiedPercentage),
  },
  {
    dataField: 'paCount',
    text: "Total Received",
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.paCount),
  },
]


export const scriptSummaryColumns=[
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
  {
    dataField: 'netPaidClaimsCount',
    text: 'Net Paid Claims Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.netPaidClaimsCount),
  },
  // {
  //   dataField: 'rejectedClaimsCount',
  //   text: 'Rejected Claims Count',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.rejectedClaimsCount),
  // },
  {
    dataField: 'scriptsby100Members',
    text: 'Scripts/1000 Lives',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => decimalFormat(row.scriptsby100Members),
  },
   {
    dataField: 'cardholderIdCount',
    text: 'Membership',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.cardholderIdCount),
  },
]


export const DrugSummaryColumns=[
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
//    {
//     dataField: 'ndc',
//     text: 'NDC',
//     sort: true,
//     width: 140,
//     show: true,
//     inputType: 'text',
//     hideColFilter: false,
//     cellRenderer: (row) => cellRendererCheck(row.ndc),
//   },
// {
//     dataField: 'drugName',
//     text: 'Drug Name',
//     sort: true,
//     width: 140,
//     show: true,
//     inputType: 'text',
//     hideColFilter: false,
//     cellRenderer: (row) => cellRendererCheck(row.drugName),
//   },
  {
    dataField: 'brandGenericFlag',
    text: 'Generic',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.brandGenericFlag),
  },
  {
    dataField: 'ssbCounts',
    text: 'SSB',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ssbCounts),
  },
    {
    dataField: 'msbCounts',
    text: 'MSB',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.msbCounts),
  },
]


export const TierSummaryDataColumns=[
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'tier',
    text: 'Tier',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.tier),
  },
   {
    dataField: 'tierCount',
    text: 'Tier Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.tierCount==0?'0':row.tierCount),
  },
{
    dataField: 'tierSpend',
    text: 'Tier Spends',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.tierSpend==0?'0':row.tierSpend),
  },
  // {
  //   dataField: 'rebateAmt',
  //   text: 'Rebate Amount',
  //   sort: true,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: false,
  //   cellRenderer: (row) => cellRendererCheck(row.rebateAmt==0 ||row.rebateAmt==null?'0':row.rebateAmt),
  // },
]

 export const TopSpecialtyDrugSummaryColumns=[
   {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
   {
    dataField: 'ndc',
    text: 'NDC',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },
{
    dataField: 'drugName',
    text: 'Drug Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
  {
    dataField: 'specialityClaimCount',
    text: 'Speciality Claim Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.specialityClaimCount==0?'0':row.specialityClaimCount),
  },
]



export const RetailvsMailOrderUtilizationSummaryColumns =[
  {
      dataField: "Options",
      text: "Options",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      // cellRenderer: (row) => renderButtons(row),
      action: true,
    },
   {
    dataField: 'monthName',
    text: 'Month',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.monthName),
  },
   {
    dataField: 'phamacyName',
    text: 'Pharmacy Name',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.phamacyName),
  },
{
    dataField: 'pharmacyNpi',
    text: 'Pharmacy NPI',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.pharmacyNpi),
  },
  {
    dataField: 'retailCount',
    text: 'Retail Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.retailCount==0?'0':row.retailCount),
  },
   {
    dataField: 'mailorderCount',
    text: 'Mail Order Count',
    sort: true,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: false,
    cellRenderer: (row) => cellRendererCheck(row.mailorderCount==0?'0':row.mailorderCount),
  },
]

 export const TopSpecialtyDrugByPMPMSummaryColumns=[
   {
    dataField: 'ndc',
    text: 'NDC',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.ndc),
  },
{
    dataField: 'drugName',
    text: 'Drug Name',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.drugName),
  },
  // {
  //   dataField: 'drugCount',
  //   text: 'Drug Count',
  //   sort: false,
  //   width: 140,
  //   show: true,
  //   inputType: 'text',
  //   hideColFilter: true,
  //   cellRenderer: (row) => cellRendererCheck(row.drugCount==0?'0':row.drugCount),
  // },
  {
    dataField: 'specialtySpend',
    text: 'PMPM',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => currencyFormat(row.specialtySpend),
      //currencyFormat(row.specialtySpend==0?'0':row.specialtySpend),
  },
  {
    dataField: 'totalSpend',
    text: 'Total Spend',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.totalSpend),
  },
  {
    dataField: 'memberCount',
    text: 'Member Count',
    sort: false,
    width: 140,
    show: true,
    inputType: 'text',
    hideColFilter: true,
    cellRenderer: (row) => cellRendererCheck(row.memberCount),
  },
]

